import AccountManages from '@/pages/accountManage/accountManages'

export default [
  {
    path: '/accountManages',
    name: 'AccountManages',
    component: AccountManages,
    meta: { name: '账户管理' }
  }
]



// WEBPACK FOOTER //
// ./src/router/accountManage/accountManages.js